import { DialogProvider } from 'src/components/molecules/dialog'

import { refreshToken } from 'src/app/auth/adapters/knap'
import { HANWHA_ORG_ID } from 'src/app/auth/constants/organization'
import { useAuthStore } from 'src/app/auth/store/auth-store'
import { NetworkStatusProvider } from 'src/app/core/hooks/use-network-status'
import { Toast } from 'src/app/core/services/toast'
import {
  setupAuthInterceptors,
  setupHanwhaOrgQueryInterceptor,
  setupOfflineInterceptor,
} from 'src/interfaces/http/interceptors'

import { queryClient, QueryClientProvider } from './queries/client'

setupOfflineInterceptor()

setupAuthInterceptors({
  getToken: () => {
    const state = useAuthStore.getState()
    return state.currentUser?.token ?? state.pendingToken
  },
  onUnauthorized: () => {
    const state = useAuthStore.getState()
    const wasAuthenticated = !!state.currentUser
    state.setCurrentUser(null)
    queryClient.clear()
    if (wasAuthenticated) {
      state.setSessionExpired(true)
    }
  },
  refreshToken,
  onTokenRefreshed: token => {
    const state = useAuthStore.getState()
    if (state.currentUser) {
      state.setCurrentUser({ ...state.currentUser, token })
    } else {
      state.setPendingToken(token)
    }
  },
})

setupHanwhaOrgQueryInterceptor({
  getOrgId: (): number => HANWHA_ORG_ID,
})

export const Providers = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  return (
    <QueryClientProvider>
      <Toast.Provider />
      <NetworkStatusProvider />
      <DialogProvider>{children}</DialogProvider>
    </QueryClientProvider>
  )
}
